import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
	selector: 'app-row-file-upload',
	templateUrl: './row-file-upload.component.html',
	styleUrl: './row-file-upload.component.scss'
})
export class RowFileUploadComponent {
	@Input() required: boolean = false;
	@Input() multiple: boolean = false;
	@Input() accept!: string;
	@Input() titles?: string[] = [];
	@Input() showTitle: boolean = true;

	@Input() icon: string | boolean = 'insert_drive_file';
	@Input() class?: string;
	@Input() layout: LAYOUT = LAYOUT.HORIZONTAL;
	readonly LAYOUT = LAYOUT;


	@Output() fileChange: EventEmitter<any> = new EventEmitter<any>();

	onFileChange(e: any) {
		this.fileChange.emit(e);
	}
}

export enum LAYOUT {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical'
}
